import React, { useState, useEffect, useCallback } from 'react';
import { callApi } from './api';
import UserTable from './UserTable';
import CreateUserForm from './CreateUserForm';
import EditUserForm from './EditUserForm';

function MaximusAdminDashboard({ onDrillDown }) {
  const [systemAdmins, setSystemAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [wipeStatus, setWipeStatus] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);

  const fetchSystemAdmins = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await callApi('listSystemAdminsV2');
      setSystemAdmins(result.users);
    } catch (err) {
      setError('Kunne ikke hente system-admins. ' + err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSystemAdmins();
  }, [fetchSystemAdmins]);

  const handleDeleteUser = async (userId) => {
    if (window.confirm('Er du sikker på at du vil slette denne system-administratoren?')) {
      try {
        await callApi('deleteUserV2', { uid: userId });
        await fetchSystemAdmins();
      } catch (err) {
        setError('Kunne ikke slette system-administrator. ' + err.message);
      }
    }
  };

  const handleFormFinished = () => {
      setShowCreateForm(false);
      setEditingUser(null);
      fetchSystemAdmins();
  }

  const handleWipeAllData = async () => {
    const confirmation = window.prompt('Dette vil slette ALL data (brukere, eiere, lokasjoner, etc.), unntatt din egen konto. Skriv "SLETT ALT" for å bekrefte.');
    if (confirmation === 'SLETT ALT') {
      setWipeStatus('Sletter all data... Dette kan ta flere minutter.');
      try {
        const result = await callApi('deleteAllBusinessDataV2');
        setWipeStatus(`Nullstilling fullført! Melding: ${result.message}`);
        fetchSystemAdmins(); // Refresh the list of admins (should be empty)
      } catch (err) {
        setWipeStatus(`Feil under nullstilling: ${err.message}`);
      }
    }
  };

  return (
    <div>
      <h2>Maximus Admin Dashboard</h2>
      
      <div style={{ border: '2px solid red', padding: '10px', margin: '20px 0', backgroundColor: '#fff0f0', color: '#333' }}>
        <h3>Faresone</h3>
        <p>Handlingen nedenfor er permanent og kan ikke angres.</p>
        <button onClick={handleWipeAllData} style={{ backgroundColor: 'red', color: 'white' }}>Nullstill Hele Systemet</button>
        {wipeStatus && <p style={{ color: 'red', fontWeight: 'bold' }}>{wipeStatus}</p>}
      </div>

      <p>Her kan du administrere alle System-administratorer.</p>
      
      {!showCreateForm && !editingUser && (
        <button onClick={() => setShowCreateForm(true)} style={{ margin: '20px 0' }}>
          + Opprett Ny System Admin
        </button>
      )}
      {showCreateForm && (
        <CreateUserForm 
            onUserCreated={handleFormFinished}
            onCancel={() => setShowCreateForm(false)}
            createFunction="createSystemAdminV2"
        />
      )}

      <h3>System-administratorer</h3>
      {loading && <p>Laster system-administratorer...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && (
        <UserTable 
          users={systemAdmins} 
          onDeleteUser={handleDeleteUser} 
          onEditUser={setEditingUser}
          {...(onDrillDown && { onViewUsers: onDrillDown })}
          isLevel1List={false}
        />
      )}

      {editingUser && (
        <EditUserForm 
          user={editingUser} 
          onFinished={handleFormFinished} 
        />
      )}
    </div>
  );
}

export default MaximusAdminDashboard;